<template>
  <footer class="site-footer">
    <!-- 图片面板 — 一半在上方白色区域，一半在蓝色 footer 内 -->
    <section class="footer-image-panel">
      <div class="footer-image-overlay"></div>
      <div class="footer-image-content">
        <h2>订阅以保持联系！</h2>
        <p>了解 19.9 的最新动态。保持知情、保持更新、保持连接！</p>
        <div class="footer-form">
          <input placeholder="请输入您的电子邮箱">
          <button>订阅</button>
        </div>
      </div>
    </section>

    <!-- 底部蓝色区域 -->
    <div class="footer-body">
      <section class="footer-main">
        <div class="footer-inner">
          <div class="footer-logo" style="font-weight: bold;font-size: 2rem;">
           圣淘沙信息科技
          </div>
          <div class="footer-info">
            <h3>地址</h3>
            <p>湖北省武汉市东湖新技术开发区民族大道219号同学广场D区1层1F-169号</p>
          </div>
          <div class="footer-info">
            <h3>联系</h3>
            <p>通过 App 或网站联系我们</p>
          </div>
        </div>
        <div class="footer-bottom">
          Copyright © 圣淘沙信息科技 2026 | All Rights Reserved |
         
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">鄂ICP备2026005930号-1</a> |
          <a href="https://www.info-linking.cn/h5/#/ProtectionGuidelines" target="_blank">隐私政策</a> |
          <a href="https://www.info-linking.cn/h5/#/Scopeofsoftwarelicense" target="_blank">用户协议</a>
        </div>
      </section>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'dibu'
}
</script>

<style scoped>
h2{
  color: #fff;
}
p{
  color: #fff;
}
.site-footer {
  position: relative;
}

/* 上方白色区 + 下方蓝色区 */
.site-footer::before {
  content: "";
  display: block;
  height: 300px;
  background: #fff;
}

.footer-body {
  background: #1B5BA6;
  color: #fff;
}

/* 图片面板 — 上下各半跨白色和蓝色 */
.footer-image-panel {
  position: absolute;
  top: 300px; /* 白色底部的分界线 */
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(960px, calc(100% - 48px));
  min-height: 480px;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 88px 48px;
  background: url("https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/gettyimages-1482692809.jpg") center/cover;
  z-index: 2;
}

.footer-image-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.footer-image-content {
  position: relative;
  z-index: 2;
  width: min(760px, 100%);
  text-align: center;
}

.footer-image-content h2 {
  font-size: clamp(42px, 6vw, 72px);
  line-height: 1.1;
  font-weight: 900;
  margin-bottom: 36px;
}

.footer-image-content p {
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 44px;
  line-height: 1.6;
}

.footer-form {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.footer-form input {
  width: min(390px, 100%);
  height: 52px;
  border: 0;
  border-radius: 5px;
  padding: 0 16px;
  font-size: 16px;
}

.footer-form button {
  height: 52px;
  border: 0;
  border-radius: 5px;
  padding: 0 26px;
  background: #1B5BA6;
  color: #fff;
  font-weight: 900;
  font-size: 16px;
  cursor: pointer;
}

.footer-main {
  padding: 350px 24px 40px;
}

.footer-inner {
  width: min(1120px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr;
  gap: 64px;
  text-align: left;
  align-items: start;
}

.footer-logo img {
  width: 230px;
}

.footer-info h3 {
  color: #bce6f7;
  font-size: 18px;
  font-weight: 900;
  margin-bottom: 18px;
}

.footer-info p {
  color: #eef7fc;
  line-height: 1.8;
  font-weight: 700;
}

.footer-bottom {
  width: min(1120px, 100%);
  margin: 56px auto 0;
  padding-top: 28px;
  border-top: 1px solid rgba(255, 255, 255, 0.22);
  color: #dce8ef;
  font-size: 14px;
}

.footer-bottom a {
  color: #dce8ef;
  text-decoration: none;
}

.footer-bottom a:hover {
  text-decoration: underline;
}

@media (max-width: 760px) {
  .site-footer::before {
    height: 220px;
  }

  .footer-image-panel {
    top: 220px;
    width: calc(100% - 32px);
    min-height: 380px;
    padding: 56px 28px;
    border-radius: 12px;
  }

  .footer-image-content h2 {
    font-size: clamp(28px, 8vw, 42px);
    margin-bottom: 22px;
  }

  .footer-image-content p {
    font-size: 16px;
    margin-bottom: 28px;
  }

  .footer-main {
    padding-top: 200px;
  }

  .footer-form,
  .footer-inner {
    grid-template-columns: 1fr;
  }

  .footer-inner {
    gap: 36px;
  }

  .footer-form {
    flex-direction: column;
    align-items: center;
  }

  .footer-form button {
    width: min(390px, 100%);
  }
}
</style>
